module.exports = __webpack_public_path__ + "static/media/es-US.a62a83f3.svg";